import { WORKFLOW_MODULE_ID } from 'constants/workflow.constants';
import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { DynamicFormField, DynamicFormSection } from 'interfaces/dynamic-form-field.interface';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { constants } from 'constants/constants';
import { SignatureComponent } from 'components/signature/signature.component';
import { DynamicFormComponent } from 'components/dynamic-form/dynamic-form.component';
import { PAGES } from '../../dynamic-details.constants';
import { DynamicFormContentDetails } from '../dynamic-form-content-details/dynamic-form-content-details.component';
import { DynamicFormValue } from 'components/multiple-dynamic-form/multiple-dynamic-form.interface';

@Component({
  selector: 'cm-dynamic-form-content',
  templateUrl: './dynamic-form-content.component.html',
  styleUrls: ['./dynamic-form-content.component.scss'],
})
export class DynamicFormContentComponent implements AfterViewInit {
  @ViewChild(SignatureComponent) signatureComponent: SignatureComponent;
  @ViewChild(DynamicFormComponent) dynamicFormComponent: DynamicFormComponent;
  @Input() modalDetails: DynamicFormContentDetails;
  @Input() formData;
  @Input() signatureLink?: string;
  @Input() isStepSubmitted = false;
  @Input() isResetEnabled = false;
  @Input() elements: DynamicFormField[] = [];
  @Input() sections: DynamicFormSection[];
  @Input() workflowTypeId: number;
  @Input() isFirstPage = false;
  @Input() disabled = false;
  readonly WORKFLOW_MODULE_ID = WORKFLOW_MODULE_ID;
  PAGES = PAGES;

  @Output() screenChange: EventEmitter<string> = new EventEmitter();
  @Output() formSubmit = new EventEmitter<any>();

  dynamicForm: UntypedFormGroup;
  showErrors = false;
  dynamicFormErrors: string[] = [];
  FIELD_TYPES = constants.FORM_FIELD_TYPE_IDS;

  constructor(private _modalService: NgbActiveModal, private cd: ChangeDetectorRef) {}

  ngAfterViewInit() {
    if (this.isStepSubmitted && this.signatureLink) {
      this.signatureComponent.signature = this.signatureLink;
    }

    if (this.formData) {
      this.dynamicFormComponent.dynamicForm.patchValue(this.formData);
      this.cd.detectChanges();
    }
  }

  dismissModal() {
    this._modalService.dismiss();
  }

  onScreenChange(page) {
    this.screenChange.emit(page);
  }

  submitForm() {
    const form = this.dynamicFormComponent.dynamicForm;
    if (form.valid) {
      this.dynamicFormErrors = [];
      this.showErrors = false;
      const formData: DynamicFormValue = { formValue: form.value };
      this.formSubmit.emit(formData);
    } else {
      this.showErrors = true;
      this.dynamicFormErrors = this.dynamicFormComponent.getFormErrorMessages();
    }
  }
}
